import { Typography, withStyles } from '@material-ui/core';
import { Card } from 'bc-front-sagacomponents';
import React from 'react';
import { TypedUseSelectorHook, useSelector } from 'react-redux';
import EnhancedTable from '../../../components/Table';
import { formatDateCourt } from '../../../helpers/formatters';
import useWindowDimensions from '../../../hooks/useWindowDimension';
import Fidelite from '../../../images/Fidelite';
import { getListeCompteFidelite } from '../../../redux/FideliteRedux';
import { RootState } from '../../../redux/reducers';
import { AdhesionAdherentParticulierResponse } from '../../../services/Api/swagger';
import { headCells } from '../helpers';
import styles from '../style';

export const useReduxSelector: TypedUseSelectorHook<RootState> = useSelector;
interface Props {
  classes?: any;
  selectedAdhesion?: AdhesionAdherentParticulierResponse;
}
const FideliteTab = (props: Props) => {
  const { classes, selectedAdhesion } = props;

  const { width } = useWindowDimensions();
  const numeroAdhesion = selectedAdhesion?.numeroAdhesion;
  const listeCompteFidelite = useReduxSelector((state) => getListeCompteFidelite(state));
  const infoFidelite = listeCompteFidelite && listeCompteFidelite?.find((adh) => adh.numeroAdhesion === numeroAdhesion);

  const buildListeTransaction =
    infoFidelite?.listeTransaction &&
    infoFidelite?.listeTransaction.map((transaction) => {
      return {
        ...transaction,
        montant: transaction.montant.toString().replace('.0', '') + '€',
        debit: (transaction.debit && transaction.debit.toString().replace('.0', '') + '€') || '-',
        credit: (transaction.credit && transaction.credit.toString().replace('.0', '') + '€') || '-',
        date: formatDateCourt(transaction.date),
      };
    });
  return (
    <div className={classes.blocAvantages}>
      {infoFidelite && selectedAdhesion && (
        <>
          <Card>
            <div className={classes.containerBlocFidelite}>
              <div className={classes.contentInfoFidelite}>
                <Fidelite width={35} height={35} />
                <div>
                  <h4>N° {selectedAdhesion.numeroFidelite}</h4>
                  <h1>{infoFidelite.solde}&nbsp;€</h1>
                  {infoFidelite.dateExpiration && infoFidelite.dateExpiration !== '0001-01-01' && (
                    <span>
                      avant le
                      {' ' + formatDateCourt(infoFidelite.dateExpiration)}
                    </span>
                  )}
                </div>
              </div>
              <p>
                L'ensemble des avantages du programme sont détaillés en concession, ils vous permettent d'accéder à des
                conditions préférentielles et privilèges exclusifs en fonction de ce qui a été défini par votre
                concessionnaire.
                <br />
                N'hésitez pas à vous renseigner auprès de lui.
              </p>
            </div>
          </Card>
          <Card className={classes.transactionArray}>
            <Typography variant="h5">Historique des transactions</Typography>
            {width > 600 ? (
              <EnhancedTable headCells={headCells()} rows={buildListeTransaction} />
            ) : (
              buildListeTransaction?.map((transaction) => {
                return (
                  <div className={classes.listeTransaction}>
                    <p>
                      <span> Date :</span> <strong>{transaction.date}</strong>
                    </p>
                    <br />
                    <p>
                      {' '}
                      <span> Détail : </span>
                      <strong>{transaction.debit}</strong>
                    </p>
                    <br />
                    <p>
                      {' '}
                      <span> Montant :</span> <strong>{transaction.montant}</strong>
                    </p>
                    <br />
                    <p>
                      {' '}
                      <span> Crédit : </span>
                      <strong>{transaction.credit}</strong>
                    </p>
                    <br />
                    <p>
                      {' '}
                      <span> Débit :</span> <strong>{transaction.debit}</strong>
                    </p>
                  </div>
                );
              })
            )}{' '}
          </Card>
        </>
      )}
    </div>
  );
};
export default withStyles(styles)(FideliteTab);
